import React from 'react';
import { Tabs, Typography, Row, Col } from 'antd';
import { IUserDetails } from 'src/interfaces';
import ContactInformation from './ContactInformation';
import UpdatePassword from './UpdatePassword';
import ProfileImage from './ProfileImage';

const { TabPane } = Tabs;
const { Title } = Typography;

type SettingsCardProps = {
    isAdmin: boolean;
    manageUser?: boolean;
    customTitle?: React.ReactElement;
    userDetails: IUserDetails;
    userDetailsLoading?: boolean;
};

function SettingsCard({
    isAdmin,
    manageUser,
    customTitle,
    userDetails,
    userDetailsLoading,
}: SettingsCardProps): React.ReactElement {
    return (
        <>
         <Row className="space-between min-width-mobile-320">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 16 }} lg={{ span: 16 }} style={{marginBottom: "10px"}}>
               <ContactInformation
                    isAdmin={isAdmin}
                    manageUser={manageUser}
                    userDetails={userDetails}
                    userId={userDetails?.id}
                    loading={userDetailsLoading}
                />
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }}>
                <ProfileImage
                    isAdmin={isAdmin}
                    userId={userDetails?.id}
                    manageUser={manageUser}
                    userDetailsPhotoSrc={userDetails?.photo}
                />
               <UpdatePassword userId={userDetails?.id} isAdmin={isAdmin} />
            </Col>
           </Row>
            
        </>
    );
}

export default SettingsCard;
